import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import TopBar from '../TopBar/TopBar';
import Footer from '../Footer/Footer';

const Layout = ({ email ,userRole}) => (
    <div className="d-flex flex-column min-vh-100">
        <TopBar email={email} userRole={userRole}/>
        <Container className="flex-grow-1 my-4">
            <Outlet />
        </Container>
        {/* <Footer /> */}
        <footer className="bg-light text-center py-3 mt-auto" 
        style={{fontSize:'12px'}}>
            Version 1.0.2 © Copyright 2024, The NielsenIQ Consumer LLC. Never guess. All Rights Reserved. Privacy Policy. Terms of Use.
        </footer>
    </div>
);

export default Layout;